import React from 'react';

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  pulse = false,
  glow = false
}) => {
  const variants = {
    default: 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-800 border border-gray-300',
    primary: 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-lg shadow-primary-500/50',
    success: 'bg-gradient-to-r from-success-500 to-success-600 text-white shadow-lg shadow-success-500/50',
    danger: 'bg-gradient-to-r from-danger-500 to-danger-600 text-white shadow-lg shadow-danger-500/50',
    warning: 'bg-gradient-to-r from-warning-500 to-warning-600 text-white shadow-lg shadow-warning-500/50',
    info: 'bg-gradient-to-r from-info-500 to-info-600 text-white shadow-lg shadow-info-500/50',
    secondary: 'bg-gradient-to-r from-secondary-500 to-secondary-600 text-white shadow-lg shadow-secondary-500/50'
  };

  const sizes = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-4 py-1.5 text-sm',
    lg: 'px-5 py-2 text-base'
  };

  const pulseClass = pulse ? 'animate-pulse' : '';
  const glowClass = glow ? 'animate-glow' : '';

  return (
    <span className={`inline-flex items-center font-bold rounded-full uppercase tracking-wide ${variants[variant]} ${sizes[size]} ${pulseClass} ${glowClass} transform hover:scale-110 transition-all duration-300 relative overflow-hidden group`}>
      <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></span>
      <span className="relative z-10">{children}</span>
    </span>
  );
};

export default Badge;
